import cx from "classnames";
import React from "react";
import { CandidateItem } from "@/appInterface/windows/VoteWindow/VoteResults/CandidateItem";
import { getDate } from "@/utils";
import { getPercent, getSortedChildren } from "./helpers";
import type { VoteEntity } from "./types";
import style from "./voteResults.module.css";

type VoteResultsProps = {
    resultsData: VoteEntity;
    selectResultItem: (UID: string) => void;
    selectedResultItemUID: string;
};

export function VoteResults({
    resultsData,
    selectResultItem,
    selectedResultItemUID,
}: VoteResultsProps) {
    const sortedChildren = React.useMemo(
        () => getSortedChildren(resultsData.children),
        [resultsData.children],
    );
    return (
        <div className={style.voteResultsWrapper}>
            <div className={style.aboutVoteWrapper}>
                <div className={style.aboutVoteTitle}>{resultsData.text}</div>
                <div className={style.aboutVoteDateAndActor}>
                    {`${getDate(new Date(resultsData.start)).replace(",", " в ")}, ${resultsData.creatorName}`}
                </div>
            </div>
            <div className={cx(style.scrollWrapper, "scrollable")}>
                {sortedChildren.map((res) => {
                    const percent = getPercent(res.votes.length, resultsData.votePerAccount);
                    return (
                        <CandidateItem
                            key={res.linkToOriginalUID}
                            res={res}
                            percent={percent}
                            selected={selectedResultItemUID === res.widgetData.UID}
                            onSelect={selectResultItem}
                        />
                    );
                })}
            </div>
        </div>
    );
}
